import type { RuntimeValue } from '../../../api/types';

export function getConfigRuntimeValues(values: RuntimeValue[]): RuntimeValue[] {
  return values.filter((value) => value.kind !== 'secret');
}

export function getSecretRuntimeValues(values: RuntimeValue[]): RuntimeValue[] {
  return values.filter((value) => value.kind === 'secret');
}

export function mergeRevealedRuntimeValue(
  values: RuntimeValue[],
  revealed: RuntimeValue & { value: string }
): RuntimeValue[] {
  return values.map((value) =>
    value.id === revealed.id
      ? {
          ...value,
          value: revealed.value,
          hasValue: revealed.value.length > 0,
        }
      : value
  );
}

export function hideRuntimeValue(
  values: RuntimeValue[],
  id: string
): RuntimeValue[] {
  return values.map((value) =>
    value.id === id ? { ...value, value: undefined } : value
  );
}
